import { render, staticRenderFns } from "./ExpenseDocList.vue?vue&type=template&id=4bd9d1e0&scoped=true"
import script from "./ExpenseDocList.vue?vue&type=script&lang=js"
export * from "./ExpenseDocList.vue?vue&type=script&lang=js"
import style0 from "./ExpenseDocList.vue?vue&type=style&index=0&id=4bd9d1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9d1e0",
  null
  
)

export default component.exports